import { useQuery } from "@tanstack/react-query";
import type { ResponsiveNotePhotoLabel } from "@rebuild/shared/models";
import { getRebuildAPI } from "@rebuild/shared/api";
import { getInternalOrgOverride } from "@/redux/actions/app.actions";
import { RESPONSIVE_NOTE_PHOTO_KEYS } from "./queryKeys";

const { estimatesControllerGetResponsiveNotePhotoLabels } = getRebuildAPI();

/**
 * The tags already applied to photos anywhere in this estimate. A free-form tag is stored only on
 * the photos it was applied to, so this is what makes one reusable later in the same estimate.
 */
export function useGetEstimatePhotoLabelsQuery(estimateId: string | undefined) {
  return useQuery({
    queryKey: RESPONSIVE_NOTE_PHOTO_KEYS.estimateLabels(estimateId ?? ""),
    queryFn: async (): Promise<ResponsiveNotePhotoLabel[]> => {
      if (!estimateId) {
        throw new Error("estimateId is required");
      }

      const orgOverride = getInternalOrgOverride();
      const response = await estimatesControllerGetResponsiveNotePhotoLabels({
        estimateId,
        ...(orgOverride ? { overrideOrganizationId: orgOverride.organizationId } : {}),
      });
      return response.data ?? [];
    },
    enabled: !!estimateId,
    staleTime: 60 * 1000,
  });
}
